import type { FaireProductEntity } from "../../entity_types/product";

export const p_v2wrmhj3qf: FaireProductEntity = {
  token: "p_v2wrmhj3qf",
  type: "product",
  name: "Kiwami Super Ceremonial Matcha - 30g",
  brandToken: "b_7jmjqz03n1",
  brandName: "Matchaful",
  imageUrl:
    "https://cdn.faire.com/fastly/ac55270935360e57646c01119c113504d6606f66f94b03007ab57adb48616d2d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c096108419fe187a6a61e687728a92b59072631dec8135cfa1e8b9ee9a0065cf.jpeg",
  ],
  priceDollars: 24,
  description:
    "Pesticide-free • Single Origin • Single Cultivar • Solar Shaded\n\n\nOur highest grade of matcha, the word Kiwami translates to “ultimate” or “extreme.” Displaying a balanced umami flavor, Kiwami presents tasting notes of florals, honey, and cream, a refreshing fragrance, and a hint of natural sweetness—it’s also the best matcha we’ve ever tasted.\n\nSustainably grown in the hills of Shizuoka, Japan, this unique tea is carefully crafted from hand-picked tea leaves of a single cultivar: the Okumidori cultivated tea variety, well-renowned for its matcha profile. This makes Kiwami rare, as most matcha is made using a blend of cultivars from multiple farms in order to achieve the desired balanced taste.\n\nSourced from a multi-generational single estate, Kiwami is ground to order from first harvest tea leaves. It is pesticide-free, fertilized with organic materials, and shaded by solar panels. At Matchaful, we believe you should know where your matcha came from and the journey it took to get to you, from farm-to-whisk™.\n\nIngredients: 100% Pure Japanese Matcha\n",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:58:14.232Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
